import { createAction } from 'redux-actions';
import { GET_TRANSLATIONS, GET_TRANSLATIONS_FAIL, GET_TRANSLATIONS_REQUEST, GET_TRANSLATIONS_CACHE, GET_TRANSLATIONS_SUCCESS } from './constants';

export const getTranslationsAction = createAction(GET_TRANSLATIONS);
export const getTranslationsRequest = createAction(GET_TRANSLATIONS_REQUEST);
export const getTranslationsCache = createAction(GET_TRANSLATIONS_CACHE);
export const getTranslationsSuccess = createAction(GET_TRANSLATIONS_SUCCESS);
export const getTranslationsFail = createAction(GET_TRANSLATIONS_FAIL);
